import { App } from '../../App'
import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'
import { updateNodeConnections } from '../../utils/functions'
import { nanoid } from 'nanoid/async'

export const toggleOutputConnectionOfNewQuestionOnCreated = (connection) => {
  const nodeOutput = connection.output.node

  if (nodeOutput.name === CONST_COMPONENT.USER_INPUT_FLOW_SINGLE) {
    const connectionKey = connection.output.key
    const nodeClass = '.node-id-' + nodeOutput.id
    const parentElement1 = $(nodeClass).find('[title=' + CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT + ']').parent()
    const parentElement2 = $(nodeClass).find('[title=' + CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY + ']').parent()
    
    let hasConnections = []
    if (connectionKey === CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT) {
      hasConnections = nodeOutput.outputs.get(CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY).connections.slice()
      parentElement1.removeClass('d-none').addClass('d-block')
      parentElement2.removeClass('d-block').addClass('d-none')
      
      delete nodeOutput.data.newPostbackId;
      
    } else if (connectionKey === CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY) {

      (async () => {
        nodeOutput.data.newPostbackId = await nanoid(15)
      })();
      
      parentElement1.removeClass('d-block').addClass('d-none')
      parentElement2.removeClass('d-none').addClass('d-block')
      hasConnections = nodeOutput.outputs.get(CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT).connections.slice()
      updateNodeConnections(nodeOutput)
    }

    if (hasConnections.length > 0) {
      hasConnections.forEach(singleConnection => {
        App.editor.removeConnection(singleConnection)
      })
    }
  }
}

export const toggleOutputConnectionOfNewQuestionOnRemoved = (connection) => {
  const nodeOutput = connection.output.node

  if (nodeOutput.name === CONST_COMPONENT.USER_INPUT_FLOW_SINGLE) {
    const nodeClass = '.node-id-' + nodeOutput.id
    const parentElement1 = $(nodeClass).find('[title=' + CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT + ']').parent()
    const parentElement2 = $(nodeClass).find('[title=' + CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY + ']').parent()
    
    if (connection.output.key === CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT) {
      parentElement1.removeClass('d-block').addClass('d-none')
      parentElement2.removeClass('d-none').addClass('d-block')

      delete nodeOutput.data.newPostbackId;

    } else if (connection.output.key === CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY) {
      parentElement1.removeClass('d-none').addClass('d-block')
      parentElement2.removeClass('d-block').addClass('d-none') 

      delete nodeOutput.data.newPostbackId;
    }
  }
}
